<template>
    <div class="ls-address-order-summary-panel grid">
        <div class="grid__col-xs-12">
            <div class="ls-address-order-summary-panel__address-map">
                <ls-address-row></ls-address-row>
                <ls-google-map
                    :address="address.googlePlace.formatted_address"
                    :lat="address.googlePlace.lat"
                    :lng="address.googlePlace.lng"
                    min-height="175px"
                ></ls-google-map>
                <ls-zillow-drawer></ls-zillow-drawer>
            </div>
        </div>
        <div class="grid__col-xs-12">
            <div>
                <!-- necessary for proper rendering on mobile safari, block element required -->
                <div class="ls-address-order-summary-panel__order-container">
                    <ls-order-summary v-if="$route.meta.showOrderSummary"></ls-order-summary>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import lsAddressRow from '@/components/original-mydot/address-row/AddressRow.vue';
import lsGoogleMap from '@/components/original-mydot/google-components/GoogleMap.vue';
import lsZillowDrawer from '@/components/original-mydot/zillow-drawer/ZillowDrawer.vue';
import lsOrderSummary from '@/components/original-mydot/order-summary/OrderSummary.vue';

export default {
    components: {
        lsAddressRow,
        lsGoogleMap,
        lsZillowDrawer,
        lsOrderSummary,
    },
    computed: {
        ...mapState(['address', 'screenSize']),
    },
};
</script>

<style lang="scss" scoped>
.ls-address-order-summary-panel__address-map {
    background-color: palette(gray, xx-light);
    @include max-screen(breakpoint(xs, max)) {
        padding-bottom: rem(-4);
    }
}

.ls-address-order-summary-panel__order-container {
    background-color: palette(gray, xx-light);
    padding: 0 rem(-2) rem(-2) rem(-2);
}
</style>
